import { ChevronDownIcon } from "@heroicons/react/24/solid"
import React, { useContext } from "react"
import { Form } from "semantic-ui-react"
import { BookerContext } from "~/contexts/BookerContext"
import BookerDropdownButton from "../../Booker/utils/BookerDropdownButton"

interface ComponentProps {
  userRigYear: number
  setUserRigYear: (v: number) => void
  error: string
  setError: (v: string) => void
  isCamperLength: boolean
}

const YearField = ({ userRigYear, setUserRigYear, error, setError, isCamperLength }: ComponentProps) => {
  const { secondaryColor } = useContext(BookerContext)

  const yearOptions = Array.from(new Array(new Date().getFullYear() + 1 - 1950), (x, i) => i + 1950)
    .reverse()
    .map((year) => {
      return { key: year, value: year, text: year }
    })

  const setValue = (v) => {
    setError("")
    setUserRigYear(v)
  }

  return (
    <div>
      <Form.Field required>
        <div className="flex justify-between items-center">
          <div className="font-bold text-lg mb-1">{isCamperLength ? 'Camper Year' : 'Rig Year'}</div>
          <BookerDropdownButton
            width="100%"
            optionPosition="center"
            options={yearOptions}
            selectedValue={userRigYear}
            secondaryColor={secondaryColor}
            setValue={setValue}
          >
            <button
              className="relative w-full cursor-default rounded-lg bg-white sm:text-sm border border-gray-300 text-center z-50 text-lg"
              style={{
                padding: "2.5px 20px 2.5px 5px",
                width: 100,
                borderRadius: ".28571429rem",
                fontSize: 18,
                height: 34,
              }}
            >
              <span className="block truncate">{userRigYear}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronDownIcon className="h-3 w-3" aria-hidden="true" />
              </span>
            </button>
          </BookerDropdownButton>
        </div>
        {error?.length ? <div className="text-red-600 font-semibold">{error}</div> : <></>}
      </Form.Field>
    </div>
  )
}

export default YearField
